module.exports = __webpack_public_path__ + "img/happy.6edcd63f.png";